// extracted by mini-css-extract-plugin
export default {"section":"ma5gRj9PAy4IIN9BXIvs","title":"sgKyxbLBu1Zt9au9duTE","hasDescription":"vz2XNcOLzDyf9KfTYSKW","description":"NZKOSrcb8ZEmhetOTJEw","pulse":"VGyH3x_qURokewmnzKYH"};